import React, { useContext } from 'react';
import withCards, { CardContext } from 'hoc/withCards';
import ListFilter from 'components/common/list-filter/ListFilter';
import PraticalFieldService from 'curricula/pratical-field/services';
import { Link } from 'react-router-dom';
import { PermissionContext } from 'hoc/withPermission';
import PraticalFieldCard from '../components/PraticalFieldCard';
import { PraticalField } from '../types';

type Props = {
  renderLoading: () => React.ReactNode;
  onChangeForm: (e: any) => undefined;
};

const PraticalFieldListPage = ({ renderLoading, onChangeForm }: Props) => {
  const { hasPermission } = useContext(PermissionContext);

  return (
    <CardContext.Consumer>
      {({ cards }) => (
        <>
          {hasPermission('academico.add_praticalfield') && (
            <div className="mb-3">
              <Link className="btn btn-primary" to="/campos-pratica/new">
                CADASTRAR CAMPO DE PRÁTICA
              </Link>
            </div>
          )}
          <ListFilter onValueChange={(e) => onChangeForm(e)} />
          <div className="card-deck">
            {renderLoading() ||
              cards.map((card: PraticalField) => (
                <PraticalFieldCard key={card.id} id={card.id} name={card.name} />
              ))}
          </div>
        </>
      )}
    </CardContext.Consumer>
  );
};

export default withCards({
  fetch: PraticalFieldService.list,
  title: 'Campos de Prática',
  paginated: true,
  noResultsText: 'Nenhuma campo de pratica foi encontrado.',
})(PraticalFieldListPage);
